import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient, HttpParams } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationServices } from '../services';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationPuduRobotsPage } from '../configuration-pudu-robots/configuration-pudu-robots';
import { ReservationLoaderPage } from '../../reservation/reservation-loader/reservation-loader';
import { OdsViewPage } from '../../ods/ods-view/ods-view';
import { ConfigurationIntegrationUberDirectPage } from './configuration-integration-uberdirect/configuration-integration-uberdirect';
import { ConfigurationIntegrationGlovoPage } from './configuration-integration-glovo/configuration-integration-glovo';

@Component({
  selector: 'page-configuration-integrations',
  templateUrl: 'configuration-integrations.html'
})

export class ConfigurationIntegrationsPage {

  option: any;

  constructor(public navCtrl: NavController,
    public globals: Globals,
    private http: HttpClient,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public configurationServices: ConfigurationServices,
    private toastCtrl: ToastController,
    public translate: TranslateService,) {

    this.option = this.navParams.get('option');
    this.checkDeliverectAuto();
  }


  async sendOpenAddon(addon_id) {

    var msg = this.translate.instant('configuration-activar-integracion') + ' ' + addon_id + ' ' + this.translate.instant('general-de') + ' ' + this.globals.restaurant.email + ' ' + this.translate.instant('configuration-con-licencia') + ': ' + this.globals.restaurant.license + ' | ' + this.translate.instant('general-telefono') + ': ' + this.globals.restaurant.phone + ' | ' + this.translate.instant('general-direccion') + ': ' + this.globals.restaurant.address + ' | ' + this.translate.instant('general-restaurante') + ': ' + this.globals.restaurant.company + '.';

    //Si la integracion es reservas abrimos el popup
    if (addon_id == 'reservas') {
      this.openWebReservation();
    } else if (addon_id == 'web') { //Si la integracion es web, vamos a la pagina de configuracion de la web
      this.openWebIntegration();
    } else if (addon_id == 'exportar cliente') { //Si la integracion es web, vamos a la pagina de configuracion de la web
      this.exportCustomers();
    } else if (addon_id == 'exportar platos deliverect') { //Si la integracion es exportar platos deliverect, le hacemos una peticion a la api
      this.exportDeliverect();
    } else {
      //
    }


    if (this.globals.checkLimitsByLicense('config', 'integrations')) {
      //caso no tiene limite send slack
      await this.http.post(this.globals.api_path + 'slack/integrations', {
        msg: msg,
      }, {}).subscribe(async data => {
        //show toast msg sended
        let toast = this.toastCtrl.create({
          message: this.translate.instant('addons-payment-finish-recibido-solicitud-activacion') + ' ' + this.translate.instant('addons-payment-finish-breve-contacto'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      },
        err => { });
    } else {
      //caso tiene limite
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async exportDeliverect() {
    if (this.globals.checkLimitsByLicense('config', 'integrations')) {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      loadingPopup.present();

      await this.http.post(this.globals.analytics_path + 'deliverect_mct_upload_products_to_deliverect', {
        uid_restaurant: this.globals.restaurant_uid
      }, {}).subscribe(async data => {
        loadingPopup.dismiss();
        //TOAST
        let toast = this.toastCtrl.create({
          message: this.translate.instant('toast-enviar-platos-a-deliverect'),
          duration: 3000,
          position: 'bottom'
        });
        toast.present();
      },
        err => {
          loadingPopup.dismiss();
        }
      );
    } else {//tiene limite 
      //this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async exportCustomers() {
    if (this.globals.checkLimitsByLicense('sales', 'customers_export')) {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      loadingPopup.present();
      //
      const body = new HttpParams()
        .set('public_key', this.globals.public_key);
      await this.http.post(this.globals.analytics_path + 'customers/customers_export', body).subscribe(async data => {
        //abrir para descargar
        if (this.globals.so_mobile) {
          window.location.assign(String(data['media_link']));
        } else {
          window.open(String(data['media_link']), '_blank');
        }
        //dismiss
        loadingPopup.dismiss();
      },
        err => {
          loadingPopup.dismiss();
        });
    } else {
      //this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }


  selectedIntegration(selected) {
    if (selected === this.option) {
      let cssClasses = {
        'integration-type-selected': true,
      }
      return cssClasses;
    }
  }

  updateDeliverectAuto(deliverect_order_autoaccept) {
    if (this.globals.checkLimitsByLicense('config', 'integrations')) {
      this.globals.restaurant.deliverect_order_autoaccept = deliverect_order_autoaccept;
      this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
        'deliverect_order_autoaccept': deliverect_order_autoaccept,
      });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  checkDeliverectAuto() {
    //Comprovamos si la opcion de deliverect_order_autoaccept es undefined
    if (this.globals.restaurant.deliverect_order_autoaccept == undefined) {
      this.globals.restaurant.deliverect_order_autoaccept = true;
    }
  }

  openWebReservation() {
    if (this.globals.checkLimitsByLicense('reservations', 'sites')) {
      //let profileModal = this.modalCtrl.create(ConfigurationIntegrationsPopupPage);
      //profileModal.present();
      this.navCtrl.setRoot(ReservationLoaderPage);
    } else {
      //this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openWebIntegration() {
    if (this.globals.checkLimitsByLicense('sites', 'web_config')) {
      this.navCtrl.setRoot(OdsViewPage);
    } else {
      //this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openPuduRobots() {
    this.navCtrl.push(ConfigurationPuduRobotsPage);
  }

  async configUberDirect() {
    if (this.globals.checkLimitsByLicense('config', 'integrations')) {
      var msg = this.translate.instant('configuration-activar-integracion') + ' UberEats Riders ' + this.translate.instant('general-de') + ' ' + this.globals.restaurant.email + ' ' + this.translate.instant('configuration-con-licencia') + ': ' + this.globals.restaurant.license + ' | ' + this.translate.instant('general-telefono') + ': ' + this.globals.restaurant.phone + ' | ' + this.translate.instant('general-direccion') + ': ' + this.globals.restaurant.address + ' | ' + this.translate.instant('general-restaurante') + ': ' + this.globals.restaurant.company + '.';
      //caso no tiene limite send slack
      await this.http.post(this.globals.api_path + 'slack/integrations', {
        msg: msg,
      }, {}).subscribe(async data => {
      },
        err => { });
      this.navCtrl.push(ConfigurationIntegrationUberDirectPage);
    } else {
      //caso tiene limite
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  configGlovo(){
    if (this.globals.checkLimitsByLicense('config', 'integrations')) {
      this.navCtrl.push(ConfigurationIntegrationGlovoPage);
    } else {
      //caso tiene limite
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-integrations/configuration-integrations.ts